
const stamps = [
    //STAMPS
    {
        alt: "tech cat",
        url: process.env.PUBLIC_URL+ "/images/deco/techcat2.jpg"
    } ,
    {
        alt: "persona 3 portable",
        url: process.env.PUBLIC_URL+ "/images/stamps/p3p.gif"
    },
    {
        alt: "persona 3",
        url: process.env.PUBLIC_URL+ "/images/stamps/p3.gif"
    },
    {
        alt: "3ds",
        url: process.env.PUBLIC_URL+ "/images/stamps/3ds.gif"
    },
    {
        alt: "gumi",
        url: process.env.PUBLIC_URL+ "/images/stamps/gumi.gif"
    },
    {
        alt: "hiimdaisy",
        url: process.env.PUBLIC_URL+ "/images/stamps/hiimdaisy.jpg"
    },
    {
        alt: "hitoshi-san",
        url: process.env.PUBLIC_URL+ "/images/stamps/hitoshi.gif"
    },
    {
        alt: "i got a leek",
        url: process.env.PUBLIC_URL+ "/images/stamps/igotaleek.gif"
    },
    {
        alt: "i love my ds",
        url: process.env.PUBLIC_URL+ "/images/stamps/ilovemyds.png"
    },
    {
        alt: "jellies",
        url: process.env.PUBLIC_URL+ "/images/stamps/jellies.gif"
    },
    {
        alt: "louis wayne",
        url: process.env.PUBLIC_URL+ "/images/stamps/louiswayne.png"
    },{
        alt: "meta",
        url: process.env.PUBLIC_URL+ "/images/stamps/meta.png"
    },
    {
        alt: "pluto",
        url: process.env.PUBLIC_URL+ "/images/stamps/pluto.jpg"
    },
    {
        alt: "she took the fucking kids",
        url: process.env.PUBLIC_URL+ "/images/stamps/shetookthefuckingkids.png"
    },
    {
        alt: "sims 3 logo",
        url: process.env.PUBLIC_URL+ "/images/stamps/Sims3Logo_2.png"
    },
    {
        alt: "spoons",
        url: process.env.PUBLIC_URL+ "/images/stamps/spoons.png"
    },
    {
        alt: "3ds",
        url: process.env.PUBLIC_URL+ "/images/stamps/warriors.gif"
    },
    {
        alt: "webkinz",
        url: process.env.PUBLIC_URL+ "/images/stamps/webkinz.png"
    },
    {
        alt: "you have no idea",
        url: process.env.PUBLIC_URL+ "/images/stamps/youhavenoidea.png"
    },
    {
        alt: "slay the princess",
        url: process.env.PUBLIC_URL+ "/images/stamps/stp_ch1_100x50_gif.gif"
    },
    {
        alt: "jerma",
        url: process.env.PUBLIC_URL+ "/images/stamps/JERMA2.gif"
    },
    {
        alt: "fish",
        url: process.env.PUBLIC_URL+ "/images/stamps/fihh.png"
    },
    {
        alt: "howl's moving castle",
        url: process.env.PUBLIC_URL+ "/images/stamps/howls_moving_castle.gif"
    },
    {
        alt: "dog of wisdom",
        url: process.env.PUBLIC_URL+ "/images/stamps/dog_of_wisdom.gif"
    },
    {
        alt: "sexy lawyers",
        url: process.env.PUBLIC_URL+ "/images/stamps/sexylawyers.png"
    },
    {
        alt: "spongebob die",
        url: process.env.PUBLIC_URL+ "/images/stamps/die.gif"
    },
]

export default stamps;